module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main/home-main.component.sass
// module id = ./src/app/modules/home/components/home-main/home-main.component.sass
// module chunks = main